<template>
  <rt-lookup
    :fetch="getLookUpDataList"
    v-bind="$attrs"
    :value="lookupValue"
    :display-fields="dialogDisplayFields"
    :alias="defaultAlias"
    @input="handleDataSelected"
    @change="handleDataChange"
    :allow-input="allowInput"    
  />
</template>
 
<script>
export default {
  name: "RtSoLookup",
  props: {
    value: {
      type: Object,
      required: false,
    },
    entity: {
      type: String,
      required: true,
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: {
      type: String,
      default: "",
    },
    dialogFilterFields: String,
    dialogCustomConditions: {
      type: String,
      default: "",
    },
    dialogReturnFields: String,
    requestUrl: {
      type: String,
      default: function () {
        return "../api/crmlookupview/data";
      },
    },
    alias: {
      type: Object,
    },
    allowInput: {
      type: Boolean,
      default: false,
    },
    clearIconName: String,
  },

  computed: {
    defaultAlias() {
      if (this.alias && this.alias.id) {
        return alias;
      } else {
        return {
          id: this.idField,
          name: this.nameField,
        };
      }
    },
    selectString: {
      get() {
        //将idField、nameField、displayFields、dialogReturnFields合并，并去掉重复的字段
        var selectFields;

        if (this.dialogReturnFields) {
          selectFields = this.dialogReturnFields.split(",");
        } else {
          selectFields = [];
        }

        selectFields.push(this.nameField);
        selectFields.push(this.idField);

        for (var i in this.dialogDisplayFields) {
          var fieldName = this.dialogDisplayFields[i].prop;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      },
    },
    orderbyString: {
      get() {
        return this.dialogOrderbyFields;
      },
    },
    conditionString: {
      get() {
        return this.dialogCustomConditions;
      },
    },
    filterString: {
      get() {
        return this.dialogFilterFields;
      },
    },
  },
  data() {
    return {
      lookupValue: {},
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          let obj = newValue;
          obj[this.idField] = newValue.id;
          obj[this.nameField] = newValue.name;
          this.lookupValue = obj;
        } else {
          this.lookupValue = {};
        }
      },
    },
  },
  mounted() {},
  methods: {
    handleDataSelected(val) {
      this.lookupValue = val;
      const reVal = val
        ? {
            id: val[this.idField],
            name: val[this.nameField],
            ...val,
          }
        : val;
      this.$emit("input", reVal);
      this.$emit("change", { ...this.selectVal, ...reVal });
    },
    handleDataChange(val) {
      this.selectVal = val || {};
    },
    //数据加载
    getLookUpDataList(page) {
      let requestStr = this.requestUrl;
      if (requestStr.indexOf("?") >= 0) {
        requestStr = this.requestUrl + "&entityName=" + this.entity;
      } else {
        requestStr = this.requestUrl + "?entityName=" + this.entity;
      }
      requestStr =
        requestStr +
        "&page=" +
        page.pageIndex +
        "&count=" +
        page.pageSize +
        "&select=" +
        this.selectString +
        "&orderby=" +
        this.orderbyString +
        "&condition=" +
        this.conditionString +
        "&filter=" +
        this.filterString +
        "&filterValue=" +
        encodeURIComponent(page.queryValue || "");
      return rt
        .get(requestStr)
        .then((res) => {
          const obj = {
            total: res.TotalRecordCount,
            data: res.Data,
          };
          return obj;
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// lookup.vue?052ed9c0